import { Skeleton } from 'design-system';

export const FeedArticleDialogSkeleton = () => (
  <div
    className='space-y-3'
    data-testid='skeleton'
  >
    <Skeleton className='h-6 w-3/4' />
    <Skeleton className='h-4 w-2/5' />
    <Skeleton className='h-4 w-full' />
    <Skeleton className='h-4 w-full' />
    <Skeleton className='h-4 w-5/6' />
  </div>
);
